import { render, staticRenderFns } from "./CardsLayout.vue?vue&type=template&id=152e5bf6&scoped=true"
import script from "./CardsLayout.vue?vue&type=script&lang=js"
export * from "./CardsLayout.vue?vue&type=script&lang=js"
import style0 from "./CardsLayout.vue?vue&type=style&index=0&id=152e5bf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152e5bf6",
  null
  
)

export default component.exports